/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AnsweredCommentContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"ReactionButtonContainer_settings" | "UserTagsContainer_settings" | "CommentContainer_settings" | "MediaSectionContainer_settings" | "UsernameWithPopoverContainer_settings">;
    readonly " $refType": "AnsweredCommentContainer_settings";
};
export type AnsweredCommentContainer_settings$data = AnsweredCommentContainer_settings;
export type AnsweredCommentContainer_settings$key = {
    readonly " $data"?: AnsweredCommentContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnsweredCommentContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReactionButtonContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MediaSectionContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UsernameWithPopoverContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '8d3f4188c19c31a41365ae94cb22a356';
export default node;
